'use client'

import * as Sentry from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({
  error
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <div className="flex h-full flex-col items-center justify-center min-h-screen dark:bg-slate-950 text-center p-4">
          <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
            Something went wrong!
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
            We are sorry, but an unexpected error has occurred.
            <br /> Please try again later.
          </p>

          <div className="flex flex-col w-full max-w-md gap-4">
            <div className="flex items-center justify-center">
              <button
                onClick={() => window.location.reload()}
                className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors duration-200 shadow-lg min-w-[120px]"
              >
                <span>Reload page</span>
              </button>
            </div>
          </div>
          <p>Error: {error.message}</p>
        </div>
      </body>
    </html>
  )
}
